// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ForceUpdate__container-e4795c {
  display: flex;
  width: 100%;
  height: 100%;
  justify-content: center;
  align-items: center;
  background: var(--base-10);
  position: absolute;
}

.ForceUpdate__content-d8f82d {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background: var(--addition-70);
  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);
  border-radius: 24px;
  padding: 70px;
}

.ForceUpdate__title-befbf8 {
  margin-top: 24px;
  color: var(--base-110);
  font: var(--font-title-6);
}

.ForceUpdate__description-facf2b {
  width: 300px;
  color: var(--base-80);
  font: var(--font-body-4);
  letter-spacing: var(--font-spacing-body-4);
  margin-top: 4px;
  text-align: center;
}

.ForceUpdate__button-baf8d0 {
  margin-top: 24px;
}`, "",{"version":3,"sources":["webpack://./src/pages/ForceUpdate/ForceUpdate.style.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AACF;;AAEA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;EACA,4CAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACE,gBAAA;EACA,sBAAA;EACA,yBAAA;AACF;;AAEA;EACE,YAAA;EACA,qBAAA;EACA,wBAAA;EACA,0CAAA;EACA,eAAA;EACA,kBAAA;AACF;;AAEA;EACE,gBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  width: 100%;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  background: var(--base-10);\n  position: absolute;\n}\n\n.content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  background: var(--addition-70);\n  box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.04);\n  border-radius: 24px;\n  padding: 70px;\n}\n\n.title {\n  margin-top: 24px;\n  color: var(--base-110);\n  font: var(--font-title-6);\n}\n\n.description {\n  width: 300px;\n  color: var(--base-80);\n  font: var(--font-body-4);\n  letter-spacing: var(--font-spacing-body-4);\n  margin-top: 4px;\n  text-align: center;\n}\n\n.button {\n  margin-top: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ForceUpdate__container-e4795c`,
	"content": `ForceUpdate__content-d8f82d`,
	"title": `ForceUpdate__title-befbf8`,
	"description": `ForceUpdate__description-facf2b`,
	"button": `ForceUpdate__button-baf8d0`
};
module.exports = ___CSS_LOADER_EXPORT___;
